import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { resolveImage } from "@/lib/api";
import api from "@/lib/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials", { params: { featured: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-24 bg-secondary" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5">
        <SectionHeading overline="Client Stories" title="Trusted across Belize." center />
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.slice(0, 6).map((t, i) => (
            <motion.div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.1 }}
              className="bg-white border border-gray-100 p-8 relative hover:border-gold hover:shadow-lg transition-all"
            >
              <Quote size={36} className="text-gold/30 absolute top-6 right-6" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={16} className={s < (t.rating || 5) ? "fill-gold text-gold" : "text-gray-300"} />
                ))}
              </div>
              <p className="text-navy leading-relaxed relative z-10">“{t.quote}”</p>
              <div className="mt-6 flex items-center gap-3">
                {t.image_path ? (
                  <img src={resolveImage(t.image_path)} alt={t.name} className="h-11 w-11 rounded-full object-cover" />
                ) : (
                  <div className="h-11 w-11 rounded-full bg-navy text-gold flex items-center justify-center font-display font-bold">
                    {t.name?.[0] || "C"}
                  </div>
                )}
                <div>
                  <div className="font-semibold text-navy text-sm">{t.name}</div>
                  {t.role && <div className="text-xs text-muted-foreground">{t.role}</div>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
